<template>
    <div class="">
        <h3 class="block-title text-center" v-if="this.content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div v-if="totalColumns > 0" style="position:relative;" @mouseenter="showOverlay = true" @mouseleave="showOverlay = false">
            <div ref="media-container" class="hide-native-scrollbar media-container p-0 d-flex" >
                <div v-for="i in totalColumns" class="media-column" :class="classForMediaColumn" :key="i">
                    <div v-for="j in lines" :key="i + '-' + j" class="media-row">
                        <div class="media-item-container" data-aspect-ratio="1:1">
                            <div v-if="((i - 1) * lines + j - 1) < items.length" class="media-item" :style="{'background-image': 'url(' + (items[(i - 1) *lines + j - 1].thumbnail_url || items[(i - 1) *lines + j - 1].media_url) + ')'}" ></div>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div v-if="alwaysShowButton || showOverlay" class="overlay">
                    <a class="follow-button d-block" target="_blank" :href="'https://instagram.com/' + user.username">@{{user.username}}</a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import api from '../../mixins/api';
    export default {
        props: ['block', 'providerId', 'context'],
        mixins: [api],
        data() {
            const content = JSON.parse(this.block.content);
            return {
                content: content,
                status: this.block.status,
                informationBlock: this.block.information_block,
                isPreparing: false,
                items: [],
                errorMessage: '',
                scrollTimerToken: null,
                showOverlay: false,
                user: null,
                lines: content.lines,
                autoScroll: content.autoScroll,
                size: content.size,
                alwaysShowButton: content.alwaysShowButton
            };
        },

        mounted() {
            this.prepare();
        },

        destroyed() {
            this.stopScroll();
        },

        computed: {
            title() {
                return this.content.meta.title || this.informationBlock.title;
            },
            totalColumns() {
                return Math.ceil(this.items.length / this.lines);
            },
            classForMediaColumn() {
                var classMap = {};
                classMap[this.size] = true;
                return classMap;
            }
        },

        methods: {
            startScroll() {
                this.scrollTimerToken = setInterval(() => {
                    var $mediaContainer = this.$refs['media-container'];
                    if ($mediaContainer) {
                        $mediaContainer.scrollLeft = $mediaContainer.scrollLeft + 1 % $mediaContainer.scrollWidth;
                    }
                }, 30)
            },
            stopScroll() {
                if (this.scrollTimerToken) {
                    clearInterval(this.scrollTimerToken);
                    this.scrollTimerToken = null;
                }
            },
            prepare() {
                this.isPreparing = true;
                try {
                    this.getIGMedia(this.providerId, false, (response, error, errors) => {
                        this.isPreparing = false;

                        if (errors && errors.length > 0) {
                            this.errorMessage = this.$t(errors[0]);
                            return;
                        }
                        this.items = response.data.media;
                        this.user = response.data.user;
                        if (this.autoScroll) {
                            this.startScroll();
                        }
                    });
                } catch (e) {}
            }
        }
    }
</script>

<style scoped lang="scss">
.media-item {
    background-position: center;
    background-size: cover;
}

.media-container {
    overflow-x: scroll;
    width: 100%;
    position: relative;

}
    .overlay {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .follow-button {
            pointer-events:all;
            text-decoration: none;
            margin-top: 1em;
            border-radius: 4px;
            padding: 4px 10px;
            background: rgba(255,255,255, 0.9);
            border: rgba(255,255,255, 0.9);
            color: #444;
            cursor: pointer;

            &:hover {
            text-decoration: none;
                transform: scale(1.1);
                transition: all 0.3s;
            }
        }
    }

.media-column {
    flex-grow: 0;
    flex-shrink: 0;
    min-width: 120px;;

    &.s {
        min-width: 120px;;
    }

    &.m {
        min-width: 200px;;
    }

    &.l {
        min-width: 320px;;
    }
}
</style>
